import React from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { useNavigation } from '~/hooks';
import { getInterNumber, isMobileNumber, isUSNumber } from '~/helpers';
import { NewSession } from '~/components/ActiveCall/types';
import { Textsms } from './styles';

type SendSMSButtonProps = {
  session: NewSession;
};

const SendSMS = ({ session }: SendSMSButtonProps) => {
  const { answered, numberFrom } = session;

  const navigate = useNavigation();

  const userCountry = useSelector(
    (state: RootStateOrAny) => state.auth.userCountry
  );

  const hasSMSCapability =
    isMobileNumber(numberFrom, userCountry) || isUSNumber(numberFrom);

  const handleClickSMSButton = () => {
    let smsMobileNumber = numberFrom;

    if (typeof numberFrom === 'string' && numberFrom.startsWith('0')) {
      try {
        smsMobileNumber = getInterNumber(numberFrom, userCountry);
      } catch (error) {
        smsMobileNumber = numberFrom;
      }
    }

    navigate.smsSenderView({
      name: smsMobileNumber,
      mobile: smsMobileNumber,
    });
  };

  return (
    <>
      {answered && hasSMSCapability && (
        <button
          type="button"
          title="SMS"
          data-test-id="btn-sms-open-from-active-call"
          disabled={!answered}
          onClick={handleClickSMSButton}>
          <Textsms />
        </button>
      )}
    </>
  );
};

export default SendSMS;
